// extracted by mini-css-extract-plugin
module.exports = {"clearance":"az_f_b"};